import AddCaregiverForm from "./AddCaregiverForm";

export default AddCaregiverForm;
